import React from 'react';
import BorderStyleIcon from '@mui/icons-material/BorderStyle';
import { BORDER_STYLES } from '../../Shapes/shapeCatalog';
import { Group, OptionCards, Section, Slider } from '../controls';
import { lastPaint } from '../nodeProps';
import { noneOption } from './noneOption';
import styles from './sections.module.css';

const MIN_WIDTH = 1;
const MAX_WIDTH = 10;
const ICON_SIZE = 18;
const ICON_STROKE = 1.6;
const DASHES = { [BORDER_STYLES.dashed]: '4 2.5', [BORDER_STYLES.dotted]: '0.1 3' };

// A small square drawn with the style's own line, so each card shows what it gives.
const styleSquare = (style) => (
    <svg width={ICON_SIZE} height={ICON_SIZE} viewBox="0 0 18 18" aria-hidden="true">
        <rect
            x="2"
            y="2"
            width="14"
            height="14"
            rx="3"
            fill="none"
            stroke="currentColor"
            strokeWidth={ICON_STROKE}
            strokeLinecap="round"
            strokeDasharray={DASHES[style]}
        />
    </svg>
);

const STYLE_CARDS = [
    { value: BORDER_STYLES.solid, label: 'Solid' },
    { value: BORDER_STYLES.dashed, label: 'Dashed' },
    { value: BORDER_STYLES.dotted, label: 'Dotted' },
].map((card) => ({ ...card, icon: styleSquare(card.value) }));

/**
 * The shape's outline (D-045, after mileboard's Stroke): style cards, then the weight on a slider. Its colour is the
 * creator's colour (the header colour dot), so it is not set here.
 */
const BorderSection = ({ values, change }) => {
    const options = [
        noneOption({ value: BORDER_STYLES.none, ariaLabel: 'No border', isLocked: lastPaint(values) === 'border' }),
        ...STYLE_CARDS,
    ];
    return (
        <Section id="border" icon={<BorderStyleIcon />} title="Border">
            <Group label="Style">
                <OptionCards label="Border style" options={options} value={values.borderStyle} onChange={(borderStyle) => change({ borderStyle })} />
            </Group>
            {values.borderStyle !== BORDER_STYLES.none && (
                <Group label="Weight" action={<span className={styles.groupValue}>{values.borderWidth} px</span>}>
                    <Slider
                        label="Border weight"
                        min={MIN_WIDTH}
                        max={MAX_WIDTH}
                        value={Math.min(values.borderWidth, MAX_WIDTH)}
                        onChange={(borderWidth) => change({ borderWidth })}
                    />
                </Group>
            )}
        </Section>
    );
};

export default BorderSection;
